import { Injectable } from '@angular/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class ServiceProviderLogoService {
    constructor(public secureApi: SecureApi) { }

    deleteLogo(url, body) {
        return this.secureApi.post(url + '/delete', body, false);
    }
}